export enum MarketGroupClassification {
  MULTIPLE_CHOICE = '1',
  YES_NO = '2',
  NUMERIC = '3',
}
